import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { BotMergeManager } from '@/components/admin/merge-bots/BotMergeManager';

export const MergeBots: React.FC = () => {
  return (
    <div className="container mx-auto p-6 space-y-6">
      <div className="flex flex-col gap-2">
        <h1 className="text-3xl font-bold">Ghép Bot</h1>
        <p className="text-muted-foreground">
          Quản lý việc ghép các bot con vào bot cha để tự động chuyển tiếp signal và phân tích lịch sử giao dịch tổng hợp
        </p>
      </div>

      <Card>
        <CardHeader>
          <CardTitle>Bot Merge Management</CardTitle>
        </CardHeader>
        <CardContent>
          <BotMergeManager />
        </CardContent>
      </Card>
    </div>
  );
};